import React from 'react';

import {
  createExample,
} from '../../services';

export default createExample([{
  title: 'Link',
  html: require('./link.html'),
  hasDarkTheme: false,
}]);



/** WEBPACK FOOTER **
 ** ./src/guide/views/link/link_example.jsx
 **/